// @flow
import { ApiBase } from 'api/api'
import { makeGetRequest } from 'api/fetchCalls'
import buildPreviewFormAnswers from 'utils/previewForm/buildPreviewFormAnswers'
import formatPreviewFormResponse from 'utils/previewForm/formatPreviewFormResponse'

import type { SessionObject } from '../../../types/session-object'
import type { TeamDetails } from '../../../types/team_details'

const loadPreviewForm = async (
  id: string,
  teamDetails: ?TeamDetails
): Promise<SessionObject> => {
  const data = await makeGetRequest(`${ApiBase}/forms/${id}`)

  const buildAnswers = buildPreviewFormAnswers(data)
  const formattedResponse = formatPreviewFormResponse(
    data,
    buildAnswers,
    teamDetails
  )

  return {
    preview: {
      id: 'session',
      isSubmitted: false,
      responses: [formattedResponse],
    },
  }
}
export default loadPreviewForm
